module.exports = __webpack_public_path__ + "img/title.a8f8.c82a2089.png";